module.exports = __webpack_public_path__ + "img/chaussetterouge_off.ac4fb3af.gif";